"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import type { FormEvent } from "react";

import { controlAuthClient } from "../../lib/auth-client";
import styles from "../auth.module.css";

export default function ControlSignInPage() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setPending(true);
    setError(null);

    try {
      const result = await controlAuthClient.signIn.email({
        email: email.trim(),
        password,
        rememberMe: false,
        callbackURL: "/control",
      });

      if (result.error) {
        setError("Access could not be verified. Check your credentials and try again.");
        return;
      }

      if (result.data && "twoFactorRedirect" in result.data && result.data.twoFactorRedirect) {
        return;
      }

      router.replace("/control");
      router.refresh();
    } catch {
      setError("Privileged authentication is temporarily unavailable.");
    } finally {
      setPending(false);
    }
  }

  return (
    <main className={styles.page}>
      <section className={styles.panel} aria-labelledby="control-sign-in-title">
        <p className={styles.eyebrow}>OPTRIXIS CONTROL · PRIVILEGED ACCESS</p>
        <h1 className={styles.title} id="control-sign-in-title">Internal sign in</h1>
        <p className={styles.lead}>
          Access is restricted to approved internal operators. A verified account, active two-factor authentication and an active Control role are required.
        </p>

        <form className={styles.form} onSubmit={submit}>
          {error ? <p className={styles.error} role="alert">{error}</p> : null}
          <div className={styles.field}>
            <label htmlFor="email">Internal account email</label>
            <input className={styles.input} id="email" type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} />
          </div>
          <div className={styles.field}>
            <label htmlFor="password">Password</label>
            <input className={styles.input} id="password" type="password" autoComplete="current-password" required value={password} onChange={(event) => setPassword(event.target.value)} />
          </div>
          <button className={styles.button} type="submit" disabled={pending}>{pending ? "Verifying…" : "Continue securely"}</button>
        </form>

        <p className={styles.note}>There is no public Control registration flow. Access must be granted internally.</p>
      </section>
    </main>
  );
}
